<template>
  <div class="flex w-full items-end mt-8 lg:mt-0">
    <div class="w-full flex flex-col items-end justify-end mt-2">
      <div
        class="flex justify-start items-center text-sm lg:text-lg
        text-grey-academy-800 z-20 h-6 lg:h-10 mb-5 lg:mb-0">
        <router-link class="pr-12 hover:text-background-academy text-grey-academy-250 md:hidden"
          :to="dashboardPath+'/timezones'" >
            <settings-icon class="w-6 text-grey-academy-300"/>
        </router-link>
        {{ $t('timezone.timezone') }}:
        <custom-select-timezone :options="timezonesArray" class="ml-2 z-30"/>
      </div>
      <div class="flex flex-row justify-start lg:text-lg text-grey-academy-800 my-2
      h-6 lg:h-10 z-30 text-sm">
        <language-switcher />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomSelectTimezone from '@/components/CustomSelectTimezone.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import TimezoneMixin from '@/mixins/TimezoneMixin';
import SettingsIcon from './SettingsIcon.vue';

export default {
  components: {
    CustomSelectTimezone,
    LanguageSwitcher,
    SettingsIcon,
  },

  computed: {
    timezonesArray() {
      return this.getTimezonesArray();
    },

    ...mapGetters({
      dashboardPath: 'auth/dashboardPath',
    }),
  },

  mixins: [TimezoneMixin],
};
</script>
